import CustomersModel from '../DataModels/Menu';
import { actionManager } from './BaseFunction';
// ///////////////
// Reducers
// ///////////////
const customersDM = new CustomersModel();
const Customers = (state = customersDM, action) => actionManager(state, action, 'customers');

export default Customers;
